import httpClient from './httpClient';

export const fetchAllStudents = async (archived = false) => {
  const { data } = await httpClient.get('/students', { params: { archived } });
  return data;
};

export const fetchStudent = async (id) => {
  const { data } = await httpClient.get(`/students/${id}`);
  return data;
};

export const createStudent = async (payload) => {
  const { data } = await httpClient.post('/students', payload);
  return data;
};

export const updateStudent = async (id, payload) => {
  const { data } = await httpClient.put(`/students/${id}`, payload);
  return data;
};

export const deleteStudent = async (id) => {
  await httpClient.delete(`/students/${id}`);
};

export const fetchTutorStudents = async (tutorId) => {
  const { data } = await httpClient.get(`/tutor/${tutorId}/students`);
  return data;
};

export const fetchParentStudent = async (parentId) => {
  const { data } = await httpClient.get(`/parent/${parentId}/student`);
  return data;
};

export const fetchParentStudents = async (parentId) => {
  const { data } = await httpClient.get(`/parent/${parentId}/students`);
  return data;
};

export const reorderStudents = async (tutorId, studentIds) => {
  await httpClient.put(`/tutor/${tutorId}/students/reorder`, studentIds);
};

export const toggleStudentStar = async (studentId) => {
  await httpClient.patch(`/students/${studentId}/star`);
};

export const archiveStudent = async (id) => {
  await httpClient.patch(`/students/${id}/archive`);
};

export const restoreStudent = async (id) => {
  await httpClient.patch(`/students/${id}/restore`);
};

export const fetchStudentSummary = async (studentId) => {
  const { data } = await httpClient.get(`/students/${studentId}/summary`);
  return data;
};

export const fetchParentJournalPreviews = async (parentId) => {
  const { data } = await httpClient.get(`/parent/${parentId}/journal-previews`);
  return data;
};

